import { z } from "zod"

export enum CertificateTrigger {
  LINEN_COMPONENTS = "LINEN_COMPONENTS",
  VISCOSE_COMPONENTS = "VISCOSE_COMPONENTS",
  POLYESTER_PES_RECYCLED_COMPONENTS = "POLYESTER_PES_RECYCLED_COMPONENTS",
  COTTON_RECYCLED_COMPONENTS = "COTTON_RECYCLED_COMPONENTS",
  POLYAMID_PA_RECYCLED_COMPONENTS = "POLYAMID_PA_RECYCLED_COMPONENTS",
  ACRYLIC_RECYCLED_COMPONENTS = "ACRYLIC_RECYCLED_COMPONENTS",
  COTTON_ORGANIC_COMPONENTS = "COTTON_ORGANIC_COMPONENTS",
  WOOL_RECYCLED_COMPONENTS = "WOOL_RECYCLED_COMPONENTS",
  WOOL_MERINOS_COMPONENTS = "WOOL_MERINOS_COMPONENTS",
  WOOL_COMPONENTS = "WOOL_COMPONENTS",
  ALL_SUPPLIER = "ALL_SUPPLIER",
  ALL_COMPONENTS = "ALL_COMPONENTS",
  FOOTWEAR = "FOOTWEAR",
  LAST_SUPPLIER = "LAST_SUPPLIER",
  LEATHER_COMPONENTS = "LEATHER_COMPONENTS",
  LAST_ACTIVITY = "LAST_ACTIVITY",
  ALL_MATERIALS = "ALL_MATERIALS",
  ALL_COMPONENTS_AND_MATERIALS = "ALL_COMPONENTS_AND_MATERIALS",
  ALL_OPERATIONS = "ALL_OPERATIONS",
  COTTON_REGENERATIVE_COMPONENTS = "COTTON_REGENERATIVE_COMPONENTS",
  COTTON_IN_CONVERSION_COMPONENTS = "COTTON_IN_CONVERSION_COMPONENTS",
  ORGANIC_HEMP_COMPONENTS = "ORGANIC_HEMP_COMPONENTS",
  SUSTAINABLE_HEMP_COMPONENTS = "SUSTAINABLE_HEMP_COMPONENTS",
  ORGANIC_JUTE_COMPONENTS = "ORGANIC_JUTE_COMPONENTS",
  SUSTAINABLE_LINEN_COMPONENTS = "SUSTAINABLE_LINEN_COMPONENTS",
  ORGANIC_LINEN_COMPONENTS = "ORGANIC_LINEN_COMPONENTS",
  SUSTAINABLE_LYOCELL_COMPONENTS = "SUSTAINABLE_LYOCELL_COMPONENTS",
  SUSTAINABLE_MODAL_COMPONENTS = "SUSTAINABLE_MODAL_COMPONENTS",
  SUSTAINABLE_MOHAIR_COMPONENTS = "SUSTAINABLE_MOHAIR_COMPONENTS",
  RECYCLED_POLYETHYLENE_COMPONENTS = "RECYCLED_POLYETHYLENE_COMPONENTS",
  POLYESTER_PES_PET_RECYCLED_COMPONENTS = "POLYESTER_PES_PET_RECYCLED_COMPONENTS",
  VISCOSE_VI_RECYCLED_COMPONENTS = "VISCOSE_VI_RECYCLED_COMPONENTS",
  WOOL_MERINOS_RECYCLED_COMPONENTS = "WOOL_MERINOS_RECYCLED_COMPONENTS",
  WOOL_MERINOS_REGENERATIVE_COMPONENTS = "WOOL_MERINOS_REGENERATIVE_COMPONENTS",
  WOOL_SUSTAINABLE_COMPONENTS = "WOOL_SUSTAINABLE_COMPONENTS",
  WOOL_REGENERATIVE_COMPONENTS = "WOOL_REGENERATIVE_COMPONENTS",
  RECYCLED_CASHMERE_COMPONENTS = "RECYCLED_CASHMERE_COMPONENTS",
  SUSTAINABLE_VISCOSE_COMPONENTS = "SUSTAINABLE_VISCOSE_COMPONENTS",
  SUSTAINABLE_LEATHER_COMPONENTS = "SUSTAINABLE_LEATHER_COMPONENTS",
  SUSTAINABLE_LEATHER_BOVINE_COMPONENTS = "SUSTAINABLE_LEATHER_BOVINE_COMPONENTS",
  SUSTAINABLE_LEATHER_SPLIT_COMPONENTS = "SUSTAINABLE_LEATHER_SPLIT_COMPONENTS",
  SUSTAINABLE_LEATHER_LAMB_COMPONENTS = "SUSTAINABLE_LEATHER_LAMB_COMPONENTS",
  SUSTAINABLE_LEATHER_COW_COMPONENTS = "SUSTAINABLE_LEATHER_COW_COMPONENTS",
  SUSTAINABLE_LEATHER_CALF_COMPONENTS = "SUSTAINABLE_LEATHER_CALF_COMPONENTS",
  SUSTAINABLE_LEATHER_BUFFALO_COMPONENTS = "SUSTAINABLE_LEATHER_BUFFALO_COMPONENTS",
  SUSTAINABLE_LEATHER_PORC_COMPONENTS = "SUSTAINABLE_LEATHER_PORC_COMPONENTS",
  SUSTAINABLE_LEATHER_SHEEP_COMPONENTS = "SUSTAINABLE_LEATHER_SHEEP_COMPONENTS",
  SUSTAINABLE_LEATHER_GOAT_COMPONENTS = "SUSTAINABLE_LEATHER_GOAT_COMPONENTS",
  ELASTANE_RECYCLED_COMPONENTS = "ELASTANE_RECYCLED_COMPONENTS",
  NEVER = "NEVER",
  WOOD_HARVESTING = "WOOD_HARVESTING",
}

// COUNTRIES
export const CountryIso3166Schema = z.enum([
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DG",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EA",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "EU",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "IC",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TA",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "UN",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
])
// LANGUAGES
export const LanguageIso6391 = {
  FR: "FR",
  EN: "EN",
  ZH: "ZH",
  PT: "PT",
  IT: "IT",
  ES: "ES",
  TR: "TR",
  DE: "DE",
  NL: "NL",
  AR: "AR",
  KO: "KO",
  JA: "JA",
  BE: "BE",
  RO: "RO",
  LT: "LT",
} as const

export const SUPPORTED_I18N_LOCALES_CLIENT_SIDE = [
  "EN",
  "FR",
  "ZH",
  "PT",
  "IT",
  "ES",
  "TR",
] as const

export const SUPPORTED_I18N_LOCALES_AGEC = [
  "EN",
  "FR",
  "DE",
  "IT",
  "ES",
  "NL",
] as const

export type Locale = (typeof SUPPORTED_I18N_LOCALES_CLIENT_SIDE)[number]
export type LocaleAgec = (typeof SUPPORTED_I18N_LOCALES_AGEC)[number]

export type LanguageIso6391 =
  (typeof LanguageIso6391)[keyof typeof LanguageIso6391]

export type TranslationDictionary = Partial<{
  [key in LanguageIso6391]: string | null
}>

export const LanguageIso6391Schema = z.enum(LanguageIso6391)
export type LanguageIso6391Type = z.infer<typeof LanguageIso6391Schema>

export const languageClientSideSchema = z.enum(["FR", "EN"])
// FAQ
export const FAQCategorySchema = z.enum([
  "DASHBOARD",
  "PRODUCTS",
  "SUPPLIERS",
  "CERTIFICATES",
  "DATA_TRANSFER",
  "OTHER",
])

// CERTIFICATES
export const CertificateStatusEnum = z.enum([
  "NOT_UPLOADED",
  "PENDING",
  "PROCESSED",
  "REJECTED",
])

export const CertificateTriggerSchema = z.enum(CertificateTrigger)
export type CertificateTriggerType = z.infer<typeof CertificateTriggerSchema>

export type CertificateStatusType = z.infer<typeof CertificateStatusEnum>

export const MaterialTypeCategorySchema = z.enum([
  "ANIMAL",
  "NATURAL",
  "SYNTHETIC",
  "ARTIFICIAL",
])

export const operationChainSchema = z.object({
  id: z.string(),
  name: z.string(),
})
export type OperationChain = z.infer<typeof operationChainSchema>

export const CertificateAttributeSchema = z.enum([
  "ENVIRONMENTAL",
  "SOCIAL",
  "AUDIT",
  "QUALITY_TESTING",
  "WOOD",
])

export type CertificateAttributeValidationType = z.infer<
  typeof CertificateAttributeSchema
>

export const CertificateCategorySchema = z.enum([
  "TRANSACTION",
  "SCOPE",
  "OTHER_INITIATIVES",
  "UNKNOWN",
])
export type CertificateCategoryType = z.infer<typeof CertificateCategorySchema>

export const Activities = z.enum([
  "FOOTWEAR_FINISHING",
  "APPAREL_MANUFACTURING",
  "FOOTWEAR_STITCHING",
  "FOOTWEAR_ASSEMBLING",
  "DUVET_BAFFLE",
  "FABRIC_APPRET",
  "FABRIC_LAMINATION",
  "FABRIC_WEAVING_OR_KNITTING",
  "FABRIC_DYEING_PRINTING",
  "YARN_PROVIDER",
  "YARN_DYEING_PRINTING",
  "LEATHER_TANNING",
  "LEATHER_DYEING_PRINTING",
  "LEATHER_APPRET",
  "ACCESSORY_PROVIDER",
  "DUVET_PRE_PROCESSOR",
  "DUVET_MATERIAL_PRODUCTION",
  "DUVET_FARM",
  "LEATHER_FARM",
  "YARN_MATERIAL_PRODUCTION",
  "FABRIC_SPINNING",
  "FABRIC_MATERIAL_PRODUCTION",
  "LEATHER_MATERIAL_PRODUCTION",
  "ACCESSORY_RAW_MATERIAL_PROVIDER",
  //Zalando types
  "BRAND",
  "CERTIFIED_ENTITY",
  //RDUE
  "FURNITURE_FINISHING",
  "FURNITURE_ASSEMBLING",
  "WOOD_PREPARATION",
  "WOOD_HARVESTING",
  "WOOD_MACHINING",
])
export type ActivitiesEnumType = z.infer<typeof Activities>

export enum SendInBlueEventType {
  REQUEST = "REQUEST",
  CLICK = "CLICK",
  DEFERRED = "DEFERRED",
  DELIVERED = "DELIVERED",
  SOFT_BOUNCE = "SOFT_BOUNCE",
  HARD_BOUNCE = "HARD_BOUNCE",
  COMPLAINT = "COMPLAINT",
  UNIQUE_OPENED = "UNIQUE_OPENED",
  OPENED = "OPENED",
  BLOCKED = "BLOCKED",
  INVALID_EMAIL = "INVALID_EMAIL",
  UNSUBSCRIBED = "UNSUBSCRIBED",
  TFG_UNKNOWN = "TFG_UNKNOWN",
  PROXY_OPEN = "PROXY_OPEN",
  ERROR = "ERROR",
}

export enum UndeliveredEventEnum {
  SOFT_BOUNCE = SendInBlueEventType.SOFT_BOUNCE,
  HARD_BOUNCE = SendInBlueEventType.HARD_BOUNCE,
  COMPLAINT = SendInBlueEventType.COMPLAINT,
  BLOCKED = SendInBlueEventType.BLOCKED,
  INVALID_EMAIL = SendInBlueEventType.INVALID_EMAIL,
  UNSUBSCRIBED = SendInBlueEventType.UNSUBSCRIBED,
  TFG_UNKNOWN = SendInBlueEventType.TFG_UNKNOWN,
}

export const UndeliveredEventsSchema = z.enum([
  SendInBlueEventType.SOFT_BOUNCE,
  SendInBlueEventType.HARD_BOUNCE,
  SendInBlueEventType.COMPLAINT,
  SendInBlueEventType.BLOCKED,
  SendInBlueEventType.INVALID_EMAIL,
  SendInBlueEventType.UNSUBSCRIBED,
  SendInBlueEventType.TFG_UNKNOWN,
])

export type UndeliveredEventType = keyof typeof UndeliveredEventEnum

export enum RDUEComplianceStatus {
  INCOMPLETE = "INCOMPLETE",
  VERIFICATION_REQUIRED = "VERIFICATION_REQUIRED",
  READY = "READY",
  COMPLIANT = "COMPLIANT",
}

export enum EcobalyseAnalysisStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
